import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Button, IconButton, makeStyles, Theme, useMediaQuery } from '@material-ui/core';
import { Field, reduxForm } from 'redux-form';
import { useNavigate } from 'react-router';
import axios from 'src/lib/axios';
import moment from 'moment';
import { getData, saveData } from 'src/utils/localDataHandler';
import CircularProgress from '@mui/material/CircularProgress';
import { fetchSmtUsage, getAgreement } from 'src/api/APIs';
import Notibar from 'src/utils/Notibar';
import { SubmitButton } from '../form/InputFields';
import { useDispatch, useSelector } from 'src/store';
import { Close } from '@mui/icons-material';
import { setSMTUsage } from 'src/slices/bkvReducer';
import SubmitLoader from '../SubmitLoader';
//import Iframe from 'react-iframe';


const accSettingsEditModalIV = {
    testingField: 'John Doe'
}

let SmtAgreementModal = (props) => {
    const { openModal, setOpenModal, url, callback } = props;
    const classes = formStyles();
    const [fetching, setFetching] = React.useState(false)
    const handleCloseModal = () => setOpenModal(false);
    const state = useSelector((state) => state.bkv);
    const dispatch = useDispatch();
    const addressData = state.address;
    const [disableBtn, setDisableBtn] = React.useState(true);


    const getMonthlyUsage = async (consentId) => {
        try {
            const startDate = moment().subtract(1, 'years').format('MM/DD/YYYY');
            const endDate = moment().subtract(1, 'days').format('MM/DD/YYYY');
            const esiid = addressData && addressData.esiid;
            fetchSmtUsage(esiid, consentId, startDate, endDate).then(async res => {
                if (res) {
                    // console.log("res", res);
                    dispatch(setSMTUsage(res, () => {
                        setFetching(false);
                        callback();
                    }))
                }
                else {
                    setDisableBtn(false);
                }
            })
        }
        catch (e) {
            console.log(e)
            setDisableBtn(false)
        }
    }

    const getUsageArray = async () => {
        try {
            let res;
            const agreement = await getAgreement(props.consentId);
            if (agreement.data.status === 'Approved') {
                res = await getMonthlyUsage(props.consentId);
            }
            else {
                setTimeout(() => {
                    getUsageArray()
                }, 2000);
            }
            return res;
        }
        catch (e) {
            console.log(e)
            setDisableBtn(false)
        }
    }

    const handleSubmit = () => {
        // api call
        setDisableBtn(true)
        setFetching(true);
        getUsageArray();

    }
    return (
        <Modal
            open={openModal}
            onClose={handleCloseModal}
        >
            <Box className={classes.root}>
                <Box className={classes.headingBox}>
                    <Box>
                        <Typography fontWeight={"bold"} className={classes.cardHeading} align='left'></Typography>
                    </Box>
                    <IconButton onClick={() => setOpenModal(false)} className={classes.closeModal}>
                        <Close />
                    </IconButton>
                </Box>
                <Box className={classes.cardContent}>
                    <iframe
                        title="success-page"
                        src={url}
                        width="100%"
                        height="400"
                        className="modal-iframe"
                        onLoad={() => {
                            setDisableBtn(false)
                        }}
                    />
                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        marginTop: "10px"
                    }}>
                        {
                            disableBtn && !fetching ?
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <CircularProgress size={40} /></Box> :
                                <SubmitButton
                                    type="button"
                                    disabled={disableBtn}
                                    onClick={() => {
                                        handleSubmit();
                                    }}
                                    variant={"contained"}
                                >Continue</SubmitButton>
                        }
                    </div>
                    <SubmitLoader open={fetching} />
                </Box>
            </Box>
        </Modal>
    );
}

SmtAgreementModal = reduxForm({
    // a unique name for the form
    initialValues: accSettingsEditModalIV,
    form: 'SmtAgreementModal',
})(SmtAgreementModal);

export default SmtAgreementModal;

export const formStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: '#FFFFFF',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: "80%",
        padding: "16px 32px",
        height: "max-content",
        [theme.breakpoints.down("md")]: {
            width: .95 * window.screen.width,
            padding: '15px',
            height: "max-content",
        }
    },
    headingBox: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "baseLine"
    },
    cardHeading: {
        font: "normal normal normal 24px/29px Roboto",
        letterSpacing: "0.14px",
        color: "#033333",
        fontWeight: "600",
        [theme.breakpoints.down("md")]: {
            font: "normal normal normal 22px/29px Roboto",
            fontWeight: "600",
        }
    },
    headingUnderline: {
        background: "#FF7676",
        border: "1px solid #FF7676",
        borderRadius: "20px",
        width: "80px",
        height: "4px"
    },
    textForSwitch: {
        font: "normal normal normal 16px/25px Roboto",
        letterSpacing: "0.12px",
        color: "#033333",
        marginRight: '20px',
        fontWeight: "600"
    },
    toggleContainer: {
        display: "flex",
        padding: "5px 0px"
    },
    feildContainer: {
        display: "flex",
        justifyContent: 'space-between'
    },
    cardDetails: {
        letterSpacing: "0.11px",
        color: "#033333",
        fontWeight: "600"
    },
    cardContent: {
        //border: "1px solid #FF919C",
        height: "80%",
    },
    closeModal: {
        letterSpacing: "0.14px",
        cursor: 'pointer',
        margin: "16px 0px"
    }
}))